import React from 'react';
import { Alert, AlertDescription, AlertIcon, Box } from '@chakra-ui/react';

export const TravelExpensesInfo = (): JSX.Element => {
  return (
    <Alert
      status="info"
      variant="left-accent"
      flexDirection="row"
      alignItems="center"
      // justifyContent="center"
      height="auto"
    >
      <AlertIcon />
      {/* mt={15} mb={15} */}
      <Box>
        {/* <AlertTitle>Skráning kostnaðar</AlertTitle> */}
        <AlertDescription>
          Hér skráir þú allan þann kostnað og kvittanir sem tilheyra ferðinni.
          Flug, gistingu eða annan þann kostnað sem sannarlega telst til
          ferðakostnaðar.
        </AlertDescription>
      </Box>
    </Alert>
  );
};
